import { observer } from "mobx-react";
import React from "react";
import ActionDefinitionStore from "../stores/ActionDefinitionStore";
import ActionFieldInputSetupForm from "./ActionFieldInputSetupForm";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: ActionDefinitionStore;
};

const ActionFieldInputSetupDialog: React.FC<Props> = ({ store }) => {
    return (
        <AppModal
            data-id-type="modal-window"
            data-id-name="edit-field-input"
            className="alpha-modal"
            title="Configure input appearance"
            open={store.editInputDialogVisible}
            closable={false}
            centered
            width={500}
            cancelButtonTitle="Cancel"
            onCancelClick={() => {
                store.setEditInputDialogVisible(false);
            }}
            cancelButtonProps={{
                "data-id": "button-edit-field-input-cancel",
            }}
            submitButtonTitle="Save"
            submitButtonProps={{
                "data-id": "button-edit-field-input-save",
                className: "dark",
                form: "edit-field-input-form",
            }}
        >
            <ActionFieldInputSetupForm store={store} />
        </AppModal>
    );
};

export default observer(ActionFieldInputSetupDialog);
